// Keep adaptive bitrate playback, while using a realistic initial estimate for
// short post videos that otherwise finish before hls.js can leave its lowest
// rendition. The player remains free to adapt down on constrained networks.
const POST_VIDEO_HLS_CONFIG = Object.freeze({
  abrEwmaDefaultEstimate: 1_500_000,
  testBandwidth: false,
});

export default POST_VIDEO_HLS_CONFIG;
